import { render, staticRenderFns } from "./routerDefaultUserType.vue?vue&type=template&id=837a9426&"
import script from "./routerDefaultUserType.vue?vue&type=script&lang=js&"
export * from "./routerDefaultUserType.vue?vue&type=script&lang=js&"
import style0 from "./routerDefaultUserType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports